import View from '../common/View';
import Text from '../common/Text';
import './Copyright.css';

const Copyright = () => {
  const currentYear = new Date().getFullYear();

  return (
    <View className="copyright">
      <Text variant="body" className="copyright-text">
        © {currentYear} JNSQ Labs Holdings LLC
      </Text>
    </View>
  );
};

export default Copyright;
